import { render, staticRenderFns } from "./WMPromotionPage.vue?vue&type=template&id=7fbe194b"
import script from "./WMPromotionPage.vue?vue&type=script&lang=js"
export * from "./WMPromotionPage.vue?vue&type=script&lang=js"
import style0 from "./WMPromotionPage.vue?vue&type=style&index=0&id=7fbe194b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports